import React from "react";
import {Tooltip} from "@mui/material";
import type {ContractDocument} from "../contractExplorerTypes.ts";
import {typeLabel} from "../contractExplorerFormat.ts";
import {SourceFocusContext} from "./sourceFocus.ts";

type Props = {
    documentId: string | undefined;
    documents: Record<string, ContractDocument>;
};

/**
 * A source reference, like a citation in an article: a quiet `[n]` after an
 * extracted value, where n is the document's number under Documents. Hover
 * names the document; a click opens the list and scrolls to it.
 */
export const SourceCite: React.FC<Props> = ({documentId, documents}) => {
    const focusSource = React.useContext(SourceFocusContext);
    const document = documentId ? documents[documentId] : undefined;
    if (!document) return null;
    const kind = typeLabel(String(document.header?.document_type ?? document.role ?? ''));
    return (
        <Tooltip arrow title={<><b>{document.file_name || document.document_id}</b><br/>{kind}</>}>
            <button
                type="button"
                className="ci-cite"
                aria-label={`Source ${document.position}: ${document.file_name}`}
                onClick={event => {
                    event.stopPropagation();
                    focusSource(document.position);
                }}>
                [{document.position}]
            </button>
        </Tooltip>
    );
};
